import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { parseOnboardingStep, type OnboardingSearch } from '../../data/club-onboarding.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { rootRoute } from '../root.tsx'

// «Componi le rose»: a page of its own, a flow with its bar at the foot. It keeps the `onboarding` of the
// guide, without drawing the guide's bar, so «Conferma» knows to go back to the dashboard.

export const officialLeveRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.officialLeve,
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => ({
    onboarding: parseOnboardingStep(search.onboarding),
  }),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { chrome: 'flow', opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/leve.tsx')),
})

export const officialLeveLink = { to: NAV_PATHS.officialLeve } as const
